import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import { fetchStandalonePromptRecommendations } from './fetchStandalonePromptRecommendations';
export const fetchStandaloneAIRecommendations = () => (dispatch, getState) => {
  const state = getState();
  if (getIsAIChatbot(state) && !hasPersistedThreads(state)) {
    void dispatch(fetchStandalonePromptRecommendations());
  }
};